"use client";

import { poppins_body_md_semibold } from "@frontend/design-system";
import styled, { css } from "styled-components";

export const DBDetailTitleShell = styled.div<{
  $width?: string;
  $minWidth?: string;
  $maxWidth?: string;
  $alignItems?: "flex-start" | "center";
}>`
  display: flex;
  align-items: ${({ $alignItems = "flex-start" }) => $alignItems};
  justify-content: flex-start;
  flex: 1;
  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${poppins_body_md_semibold}
  background: #f0f2f4;
  padding: 0.8rem;
  border-right: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);

  ${({ $width }) =>
    $width &&
    css`
      width: ${$width};
      max-width: ${$width};
    `};

  ${({ $minWidth }) =>
    $minWidth &&
    css`
      min-width: ${$minWidth};
    `};

  ${({ $maxWidth }) =>
    $maxWidth &&
    css`
      max-width: ${$maxWidth};
    `};
`;
